import { animated } from 'react-spring/renderprops'
import styled from '@emotion/styled'
import { css } from 'emotion'
import { getEmbeddedViewFlag } from 'portal-modules/common/utils/get-embedded-flag'
import getProjectConditions from 'portal-modules/common/utils/get-project-conditions'
const { isRP } = getProjectConditions()
// this gets added to #root to make it push away & blur
// whenever an action modal is opened
export const rootStyle = css`
  filter: blur(5px);
  opacity: 0.5;
  transform: scale(0.8);
`

// style to adjust the portal div created by Modal
export const portalStyle = css`
  align-items: center;
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  overflow-y: auto;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 5;
`

export const StyledWrapper = animated(styled('div')`
  margin: 24px;
  max-width: 400px;
  width: calc(100% - 48px);
`)

export const StyledModalDiv = styled('div')`
  background: ${({ theme }) =>
    getEmbeddedViewFlag()
      ? theme.embedded.foreground_color
      : isRP
        ? theme.mode.reskinBackground
        : theme.white.base};
  display: flex;
  flex-direction: column;
  padding-bottom: 24px;
  width: 100%;
  border-radius: ${({ theme }) => theme.mode.card_border_radius};
`

export const StyledTitle = styled('h6')`
  border-bottom: 1px solid
    ${({ theme }) =>
      getEmbeddedViewFlag() ? theme.primary.base : theme.gray.light};
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.primary.base : theme.gray.gray5};
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  padding: 12px 16px;
`

export const StyledContent = styled('div')`
  height: 100%;
  max-height: 65vh;
  overflow: auto;
  padding: 24px 24px 0;
`

export const StyledFooterContent = styled('div')`
  padding: 24px 24px 0;
`
